import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(theme => ({
    sortModeCategories: {
        marginBottom: 16,
    },
    sortModeProducts: {
        height: 'calc(100vh - 260px)',
        overflowY: 'scroll',
    },
    prodcutsContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch',
        width: '100%;',
        maxWidth: '100vw',
    },
    banners: {
        position: 'relative',
        minHeight: '400px',
        display: 'flex',
        // justifyContent: 'center',
        // alignItems: 'center',
        [theme.breakpoints.down('sm')]: {
            flexDirection: 'column',
        }
    },
    bannersContent: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        maxHeight: 300,
        overflowY: 'auto',
        [theme.breakpoints.down('sm')]: {
            padding: '26px 5px',
            borderRadius: 5,
            border: '0.5px solid #DADCE0',
            background: 'white',
            boxSizing: 'border-box',
        }
    },
    bannerWrap: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    banner: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',

        marginBottom: 16,
        padding: 16,

        width: '100%',
        minHeight: 60,
        background: 'white',
        boxShadow: '0px 14px 23px rgba(232, 228, 228, 0.5)',
        borderRadius: 5,
        boxSizing: 'border-box',
    },
    productCard: {

        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',

        marginBottom: 16,
        padding: 16,

        minHeight: 60,
        background: 'white',
        boxShadow: '0px 14px 23px rgba(232, 228, 228, 0.5)',
        borderRadius: 5,
        boxSizing: 'border-box',

        width: 'calc(100vw - 300px)',
        [theme.breakpoints.down('sm')]: {
            width: '100%',
        }
    },
    dnd: { 
        width: 64,
        textAlign: 'center',
        position: 'relative',
        top: '-9px',
        cursor: 'pointer',
    },
    imageWrap: {
        width: 67,
        height: 56,
        borderRadius: 5,
    },
    image: {
        width: '100%',
        height: '100%',

        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',

        // '&:hover': {
        //     opacity: .75,
        // }
    },
    titleWrap: {
        marginLeft: 16,
    },
    title: {
        fontSize: 16,
        fontWeight: 500,
        color: 'black',
    },
    noBanners: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: 'calc(100% - 90px)',

        display: 'flex',
        justifyContent: 'center',

        fontFamily: 'Roboto',
        fontWeight: 500,
        fontSize: 16,
        lineHeight: 1,
        alignItems: 'center',
        color: '#476282',
        [theme.breakpoints.down('sm')]: {
            height: 'auto',
            lineHeight: '54px',
        }
    },
    buttonsWrap: {
        position: 'absolute',
        bottom: 0,
        left: 'calc(50% - 190px)',
        [theme.breakpoints.down('sm')]: {
            position: 'static',
            width: '100%',
        }
    },
    buttons: {
        // position: 'absolute',
        bottom: 0,
        left: 0,
        display: 'flex',
        justifyContent: 'center',
        width: '100%',
        [theme.breakpoints.down('sm')]: {
            flexDirection: 'column',
        }
    },
    addBanner: {
        marginRight: 40,
        color: '#326DFF',
        backgroundColor: '#E9F1FC',
        [theme.breakpoints.down('sm')]: {
            marginRight: 0,
        },
        '&:hover': {
            color: 'white',
        }
    },
    controlWrap: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    bannerContentWrap: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    
    copyCategoryWrapper: {
        position: 'relative',
    },
    copyCategory: {
        display: 'flex',
        position: 'relative',
        top: 5,
        right: '12px',
        cursor: 'pointer',
        '&:hover > div': {
            color: 'gray',
        },
        '&:hover > div > svg': {
            background: '#326dff',
        }
    },
    copyLinkIcon: {
        position: 'relative',
        top: '-6px',
        left: '-7px',
        transform: 'rotate(45deg)',
        '& > svg': {
            fontSize: 18,
            padding: 4,
            fill: 'white',
            background: '#ccc',
            borderRadius: '50%',
        }
    },
    copyLinkText: {
        fontSize: 12,
        fontWeight: 400,
        color: '#ccc',
        textDecoration: 'underline',
    },
    alertWrapper: {
        position: 'absolute',
        top: '0',
        left: '0',
    },
    copyLinkIconActive: {
        '& > svg': {
            background: '#326dff',
        }
    },
    copyLinkTextActive: {
        color: '#326dff',
    },
    buttonWrap: {
        marginTop: 16,
        textAlign: 'center',
    },
    button: {
        width: 180,
        height: 45,
        // background: '#E9F1FC',
        background: 'rgb(50, 109, 255);',
        borderRadius: '5px',
        fontSize: 14,
        textTransform: 'none',
        fontWeight: 500,
        boxShadow: 'none',
        border: 'none',
        color: 'white',
        '&:hover': {
            background: 'rgb(84, 133, 255);',
            boxShadow: 'none',
        }
    },
    listCategories: {
        display: 'flex',
        alignItems: 'center',
        margin: 0,
        padding: '10px 0',
        overflowX: 'auto',

        width: 'calc(100vw - 300px)',
        [theme.breakpoints.down('sm')]: {
            width: '100%',
        }
    },
    category: {
        display: 'flex',
        marginRight: 10,
        padding: '10px 25px',
        boxShadow: '0px -1px 14px rgba(0, 0, 0, 0.09)',
        borderRadius: 8,
        cursor: 'pointer',
        margin: '0px 10px',
        fontWeight: 600,
        textDecoration: 'none',
        textAlign: 'center',
        whiteSpace: 'nowrap',
        '&.active': {
            backgroundColor: '#326DFF',
            color: 'white',
        }
    },
    activeCategory: {
        background: '#326dff',
        color: '#fff',
    }
}));